
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#plots'), APPLICATION._PATH_PREFIX + 'plot/plots', 'Plot', 'plots')        
      }

    },

    // Plots scripts
    plots:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process links
        APPLICATION._APPLICATION.processLinks('#plots', 'Plot', 'plots')

        // Get the development
        var development = $('#development_id')

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          // If no brand or company
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }

          // Otherwise
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'dropdown')
          }

        }
        ).addClass('js-ignore').trigger('change')

      }

    },

    // Upload scripts
    upload:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Get the development
        var development = $('#development_id')

        // On changing the brand or company
        $('#brand_id, #company_id').not('.js-ignore').change(function ()
        {

          // Get the brand ID
          var brand_id = $('#brand_id').val()

          // Get the company ID
          var company_id = $('#company_id').val()

          // If no brand or company
          if ('' === brand_id || '' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }

          // Otherwise
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/dropdown/' + company_id + '/' + brand_id + '?development_id=' + development.val(), 'Development', 'dropdown')
          }

        }
        ).addClass('js-ignore')

      }

    },

    callOff:
    {

      _init: function ()
      {

        var development = $('#development_id')

        $('#company_id').not('.js-ignore').change(function ()
        {

          var company_id = $(this).val()

          if ('' === company_id)
          {

            development.next('.dropdown-menu').html('')

            development.trigger('change')

          }

          else
          {

            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'coinsDropdown', function ()
            {
              development.trigger('change')
            }
            )

          }

        }
        ).addClass('js-ignore').trigger('change')

        development.not('.js-ignore').change(function ()
        {

          if ('' === $(this).val())
          {
            $('#add-plot-button').hide()
          }

          else
          {
            $('#add-plot-button').show().data(APPLICATION._DATA_PREFIX + 'modal', APPLICATION._PATH_PREFIX + 'plot/call-off-plot/' + $(this).val())
          }

          APPLICATION._APPLICATION.load($('#pending'), APPLICATION._PATH_PREFIX + 'plot/installations/' + $(this).val() + '?pending=1', 'Plot', 'installations')

          APPLICATION._APPLICATION.load($('#completed'), APPLICATION._PATH_PREFIX + 'plot/installations/' + $(this).val(), 'Plot', 'installations')

        }
        ).addClass('js-ignore').trigger('change')

      },

      addPlot: function (plot)
      {

        $('#plots').append('<div class="input-group" style="margin-bottom: 10px"><input type="hidden" name="plots[]" value="' + plot + '"><span class="input-group-addon">' + plot + '</span><span class="input-group-btn" style="width: 100%"><a href="javascript:" class="btn btn-danger" onclick="APPLICATION.Plot.callOff.deletePlot(this, \'' + plot + '\')"><span class="fa fa-trash"></span></a></span></div>')

        $('body').removeClass('show-modal')

      },

      deletePlot: function (element, plot)
      {
        element.closest('.input-group').remove()
      }

    },

    callOffPlot:
    {

      _init: function ()
      {

        $('#plot, .js-option').not('.js-ignore').change(function ()
        {
          APPLICATION.Plot.callOffPlot.validate()
        }
        ).addClass('js-ignore').trigger('change')

        $('#property_type').not('.js-ignore').change(function ()
        {

          $('.js-option').hide()

          if ($('#property_type').val())
          {
            $('.js-option[data-' + APPLICATION._DATA_PREFIX + 'option=' + $(this).val() + '], .js-option[data-' + APPLICATION._DATA_PREFIX + 'option=3]').show()
          }

          APPLICATION.Plot.callOffPlot.validate()

        }
        ).addClass('js-ignore').trigger('change')

      },

      validate: function ()
      {

        var disabled = '' === $('#plot').val() || '' === $('#property_type').val() || 0 !== $('.js-option input:visible:not(:checked)').length

        $('#add-plot').prop('disabled', disabled)

      }

    }

  }